import { render, staticRenderFns } from "./CarsIntroduction-detail.vue?vue&type=template&id=b9e546e4&scoped=true&"
import script from "./CarsIntroduction-detail.vue?vue&type=script&lang=js&"
export * from "./CarsIntroduction-detail.vue?vue&type=script&lang=js&"
import style0 from "./CarsIntroduction-detail.vue?vue&type=style&index=0&id=b9e546e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e546e4",
  null
  
)

export default component.exports